export default "__VITE_ASSET__CGDFs_mm__"